import script from "./DataSpanshot.vue?vue&type=script&setup=true&lang=js"
export * from "./DataSpanshot.vue?vue&type=script&setup=true&lang=js"

import "./DataSpanshot.vue?vue&type=style&index=0&id=99fea19c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99fea19c"]])

export default __exports__